"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCommonDataProvider = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const useInterval_1 = require("../../hooks/useInterval");
const redux_injectors_1 = require("../../utils/@reduxjs/redux-injectors");
const utils_1 = require("../ConfigProvider/utils");
const types_1 = require("../ConfigProvider/types");
const slice_1 = require("./slice");
const saga_1 = require("./saga");
const selectors_1 = require("./selectors");
const POLLING_INTERVAL_ON_ERROR = 2000;
const useCommonDataProvider = () => {
    (0, redux_injectors_1.useInjectReducer)({ key: slice_1.sliceKey, reducer: slice_1.reducer });
    (0, redux_injectors_1.useInjectSaga)({ key: slice_1.sliceKey, saga: saga_1.commonDataProviderSaga });
    const { error } = (0, react_redux_1.useSelector)(selectors_1.selectCommonDataFetchItems);
    const allCommonDataLoaded = (0, react_redux_1.useSelector)(selectors_1.selectIsAllCommonDataLoaded);
    const dispatch = (0, react_redux_1.useDispatch)();
    const isNewFetchCommonData = (0, utils_1.useFeatureFlag)(types_1.EFeatureFlags.FETCH_COMMON_DATA_NEW);
    const pollingInterval = (0, react_1.useMemo)(() => {
        if (isNewFetchCommonData) {
            return allCommonDataLoaded ? null : POLLING_INTERVAL_ON_ERROR;
        }
        return error ? POLLING_INTERVAL_ON_ERROR : null;
    }, [error, allCommonDataLoaded, isNewFetchCommonData]);
    const refetchCommonData = (0, react_1.useCallback)(() => {
        if (isNewFetchCommonData) {
            dispatch(slice_1.commonDataProviderActions.refetchCommonData());
        }
        else {
            dispatch(slice_1.commonDataProviderActions.fetchCommonData({}));
        }
    }, [isNewFetchCommonData, dispatch]);
    (0, useInterval_1.useInterval)(refetchCommonData, pollingInterval);
};
exports.useCommonDataProvider = useCommonDataProvider;
exports.useCommonDataProvider.prefetch = ({ store }) => {
    store.dispatch(slice_1.commonDataProviderActions.fetchCommonData({ fromServer: true }));
};
exports.useCommonDataProvider.set = ({ store, data }) => {
    store.dispatch(slice_1.commonDataProviderActions.setCommonData({ data }));
};
exports.useCommonDataProvider.cacheKey = slice_1.sliceKey;
//# sourceMappingURL=useCommonDataProvider.js.map